export default __webpack_public_path__ + "static/media/icons8-edit-48.5f69a22a.svg";